import { Document, Page } from '@react-pdf/renderer';
import './styles.css';
import { observer } from 'mobx-react-lite';
import Html from 'react-pdf-html';
import ReactDOMServer from 'react-dom/server';
import { IFormDetails } from '../../../app/stores/dashboardConfiguration/types';
import { useEffect, useState } from 'react';
import {
  additionalVendorDetails,
  invoiceSideContent,
  invoiceTableType,
  number2text,
  rentalAssetDetails,
  vendorDetails,
} from './type';
import { dateTimeStamp } from '../../MediaAssets/NFAI_Report/ColorGrading';

interface Props {
  formDetails: IFormDetails[];
}

const LvpcmsInvoice = ({ formDetails }: Props) => {
  const [tableData, setTableData] = useState<any>({});
  const [dynData, setDynData] = useState<any>({});
  const element = (
    <html>
      <body>
        <style>{`
        * {
              font-size: 9px;
            }
            .line-height-2 {
              line-height: 1.5px;
            }
            .margin-0 {
              margin: 0px;
            }
            .margin-bottom-7 {
              margin-bottom: 7px;
            }
            #container {
              margin: 20px;
            }
            .small-font {
              font-size: 7px;
            }
            .bold-text {
              font-weight: 700;
            }
            .center-content {
              text-align: center;
            }
            .invoice-table,
        .invoice-table th,
        .invoice-table td {
          border: 1.2px solid black;
          border-collapse: collapse;
        }
        .invoice-table table,
        .invoice-table table th, .invoice-table table td {
          border: none;
          border-collapse: collapse;
        }
        .padding-4 {
              padding: 4px;
            }
            .padding-2 {
              padding: 2px;
            }
            .padding-left-4 {
              padding: 4px 4px 4px 8px;
            }
            .l-grey-bg {
              background-color: lightgray;
            }
            .grey-bg {
              background-color: gray;
            }
            .border-top-0 {
              border-top: 0px;
            }
            .underline {
              text-decoration: underline;
            }
            .white-text {
              color: white;
            }
            .spacing-50 {
              margin-bottom: 50px;
            }
            .spacing-100 {
              margin-bottom: 100px;
            }
            .italics-style {
              font-style: italic;
            }
            .width-50 {
              width: 50px;
            }
            .float-right {
              float: right !important;
            }
            .spacing-25{
              margin-bottom: 25px;
            }
            .margin-right-50 {
              margin-right: 96px;
            }
        `}</style>
        <div id="container">
          {/* <img
            src="/assets/LVPCMS.png"
            alt="LVPCMS Logo"
            width={200}
            height={50}
            className="margin-bottom-7"
          /> */}
          <h2 className="center-content margin-0 margin-bottom-7">
            PURCHASE ORDER
          </h2>
          <table className="invoice-table">
            <thead></thead>
            <tbody>
              <tr>
                <td className="padding-2 line-height-2">
                  <span className="underline">Invoice to:</span> <br />
                  <b className="bold-text">
                    L. V. Prasad College of Media Studies -
                  </b>{' '}
                  <br />
                  <span className="small-font">{`(A Unit of L. V. Prasad Education and Research Foundation)`}</span>
                  <br />
                  58, Arunachalam Road, <br />
                  Saligramam, Chennai - 600 093. <br />
                  GST No: 33AAECL8800E1ZU <br />
                  GSTIN/UIN: 33AAECL8800E1ZU
                </td>
                <td className="padding-2 line-height-2">
                  <table>
                    <tbody>
                      {invoiceSideContent?.map((i: string) => {
                        return (
                          <tr className="border-top-0">
                            <td className="bold border-top-0">{i}</td>
                            <td className="border-top-0">{tableData[i]}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td className="padding-2 line-height-2">
                  <span className="underline">{`Supplier (Bill from)`}</span>
                  <br />
                  {vendorDetails?.map((v: string) => {
                    return (
                      <>
                        {tableData[v]}
                        <br />
                      </>
                    );
                  })}
                  {additionalVendorDetails?.map((v: string) => {
                    return (
                      <>
                        {v} : {tableData[v]}
                        <br />
                      </>
                    );
                  })}
                </td>
                <td className="padding-2 line-height-2">
                  <span className="underline">{`Terms of Delivery`}</span>
                  <br />
                  {tableData[`Terms of Delivery`]}
                </td>
              </tr>
            </tbody>
          </table>
          <table className="invoice-table margin-bottom-7">
            <thead>
              <tr>
                {dynData?.['headers']?.map((headerName: string) => {
                  return (
                    <th
                      className="padding-4 bold grey-bg border-top-0 white-text"
                      key={headerName}
                    >
                      {headerName}
                    </th>
                  );
                })}
                {/* <th className="padding-4 bold grey-bg border-top-0 white-text">
                  Description of Goods
                </th>
                <th className="padding-4 bold grey-bg border-top-0 white-text">
                  Quantity
                </th>
                <th className="padding-4 bold grey-bg border-top-0 white-text">
                  Rate
                </th>
                <th className="padding-4 bold grey-bg border-top-0 white-text">
                  Disc. %
                </th>
                <th className="padding-4 bold grey-bg border-top-0 white-text">
                  Amount
                </th> */}
              </tr>
            </thead>
            <tbody>
              {dynData['body']?.map((r: any) => {
                return (
                  <tr>
                    {dynData['headers']?.map((headerName: string) => {
                      return (
                        <td
                          className="padding-left-4"
                          style={
                            headerName !== 'Description of Goods'
                              ? { textAlign: 'right' }
                              : {}
                          }
                        >
                          {typeof r[headerName] === 'object'
                            ? JSON.stringify(r[headerName])
                            : r[headerName]}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
              <tr>
                <td className="padding-4 l-grey-bg">Total</td>
                <td className="padding-4" style={{ textAlign: 'right' }}>
                  {tableData['Total Rental Quantity']} Nos
                </td>
                <td className="padding-4"></td>
                <td className="padding-4"></td>
                <td className="padding-4" style={{ textAlign: 'right' }}>
                  {isNaN(parseInt(tableData['Total Rental Amount']))
                    ? '₹ 0'
                    : parseInt(
                        tableData['Total Rental Amount'],
                      )?.toLocaleString('en-IN', {
                        maximumFractionDigits: 2,
                        style: 'currency',
                        currency: 'INR',
                        currencyDisplay: 'code',
                      })}
                </td>
              </tr>
            </tbody>
          </table>
          <h5 className="margin-0 margin-bottom-7">{`Amount Chargeable (In Words)`}</h5>
          <h4 className="margin-0 spacing-50">
            INR {number2text(tableData['Total Rental Amount'])}
          </h4>
          <div className="line-height-2">
            <span className="italics-style">Remarks</span>
            <br />
            <span>{`For Educational Fair [Outreach & Admission]`}</span>
            <br />
            <br />

            <table className="CGR-table border-top-0">
              <tbody>
                <span className="underline">Declaration</span>
                <tr>
                  <td className="margin-right-50">
                    <br />
                    <span className="margin-right-50">
                      We declare that this invoice shows the actual price of the
                      goods described and that all particulars are true and
                      correct.
                    </span>
                  </td>
                  <td className="border-top-0 margin-left-50">
                    <div className="float-right">
                      <div className="spacing-25">
                        for L. V. Prasad College of Media Studies
                      </div>
                      Authorised Signatory
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <div className="spacing-100 center-content">
            This is a Computer Generated Document
          </div>
        </div>
      </body>
    </html>
  );

  const getDynamicTableData = (eleVal: string) => {
    const temp: any = {};
    temp['headers'] = [];
    temp['body'] = [];
    let columnHeaders: string[] = [];
    let tempValue = [];
    if (eleVal?.includes('DynamicTable|')) {
      let stringData = eleVal?.split('DynamicTable|')?.[1];
      stringData = stringData?.split('_')?.join(' ');
      tempValue = stringData !== undefined ? JSON.parse(stringData) : [];
      if (tempValue[0]) {
        columnHeaders = Object.keys(tempValue[0]);
        columnHeaders = columnHeaders?.filter((data) => data !== ' uuid ');
      }
    }
    temp['headers'] = columnHeaders;
    temp['body'] = tempValue;
    setDynData(temp);
  };

  useEffect(() => {
    const initialTableType: invoiceTableType = {
      'Voucher No.': '',
      Dated: '',
      'Mode/Terms of Payment': '',
      'Reference No': '',
      'Other References': '',
      'Dispatched through': '',
      Destination: '',
      'Vendor Name': '',
      'Vendor Address': '',
      'GSTIN/UIN': '',
      'State Name': '',
      Code: '',
      'Terms of Delivery': '',
      'Asset to be Rented': [],
      'No of Units': '',
      'Rent per Day': '',
      'Total Rental Amount': '',
      'Total Rental Quantity': '',
    };
    let tempTableData: invoiceTableType = initialTableType;
    formDetails?.forEach((data: IFormDetails) => {
      if (invoiceSideContent.includes(data.elementName)) {
        tempTableData[data.elementName as keyof invoiceTableType] =
          data.elementValue;
      } else if (vendorDetails.includes(data.elementName)) {
        tempTableData[data.elementName as keyof invoiceTableType] =
          data.elementValue;
      } else if (additionalVendorDetails.includes(data.elementName)) {
        tempTableData[data.elementName as keyof invoiceTableType] =
          data.elementValue;
      } else if (rentalAssetDetails.includes(data.elementName)) {
        getDynamicTableData(data.elementValue);
      } else if (data.elementName.includes('Request Raised At')) {
        tempTableData['Dated'] = dateTimeStamp(data.elementValue);
      } else if (data.elementName.includes('Terms of Delivery')) {
        tempTableData['Terms of Delivery'] = data.elementValue;
      } else if (data.elementName.includes('Total Rental Amount')) {
        tempTableData['Total Rental Amount'] = data.elementValue;
      } else if (data.elementName.includes('Total Rental Quantity')) {
        tempTableData['Total Rental Quantity'] = data.elementValue;
      }
    });
    setTableData(tempTableData);
  }, [formDetails]);

  const html = ReactDOMServer.renderToStaticMarkup(element);
  return (
    <Document>
      <Page>
        <Html>{html}</Html>
      </Page>
    </Document>
  );
};

export default observer(LvpcmsInvoice);
